// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import { useSelector } from "react-redux";
// import Main from "./Main";
// import AddFund from "../components/AddFund";
// import { fetchTeamMembers } from "../api/teamsMemeberApi";
// import { autoDateFormat } from "../utils/autoDateFormate";
// import { checkTeamWalletById } from "../api/walletsApi";
// import { useNavigate } from "react-router-dom";
// import { formatAmount } from "../utils/formatAmount";
// import { REAL_BASE_URL } from "../api/axiosInstance";
// import { useNotify } from "../context/NotifyContext";
// import { useBranding } from "../context/BrandingContext";
// import blueLogo from "../assests/newbrand/13.svg";
// import {
//   buildTeamMemberDocument,
//   cacheTeamMember,
//   downloadTeamMemberPdf,
//   printTeamMember,
// } from "../utils/teamMemberDocument";
// import {
//   ListingFilters,
//   ListingPagination,
//   SortableTh,
//   AppBreadcrumbs,
//   RowActions,
//   StatusBadge,
//   useListingState,
//   TEAM_STATUS_OPTIONS,
//   TEAM_ACCOUNT_STATUS_OPTIONS,
//   CompactSelect,
// } from "../components/listing";
// import { exportTable } from "../utils/downloadExcel";

// const activeStatusLabel = (member) => {
//   if (typeof member?.isActive === "boolean") {
//     return member.isActive ? "ACTIVE" : "INACTIVE";
//   }
//   return "INACTIVE";
// };

// const TeamMembers = () => {
//   const { userInfo } = useSelector((state) => state?.auth);
//   const { notify } = useNotify();
//   const { companyName, legalName, mediaUrl, settings } = useBranding();
//   const [open, setOpen] = useState(false);
//   const listing = useListingState({
//     sortBy: "date",
//     sortDir: "desc",
//     includeDates: true,
//     startDate: "",
//     endDate: "",
//     status: "active",
//     accountStatus: "",
//   });
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalbyall, setTotalbyAll] = useState(0);
//   const [members, setTeamMembers] = useState([]);
//   const [walletBalances, setWalletBalances] = useState({});
//   const [balanceLoading, setBalanceLoading] = useState({});
//   const [selectedMember, setSelectedMember] = useState(null);
//   const navigate = useNavigate();

//   const brand = useMemo(() => {
//     const logoPath = settings?.logoLightUrl || settings?.logoDarkUrl;
//     return {
//       companyName,
//       legalName,
//       logoUrl: logoPath ? mediaUrl(logoPath) : blueLogo,
//     };
//   }, [companyName, legalName, mediaUrl, settings]);

//   const fetch_teams = async () => {
//     const params = {
//       page: listing.page,
//       limit: listing.limit,
//       search: listing.debouncedSearch || undefined,
//       sortBy: listing.sortBy || undefined,
//       sortDir: listing.sortBy ? listing.sortDir : undefined,
//       status: listing.status || undefined,
//       accountStatus: listing.accountStatus || undefined,
//       role: listing.role || undefined,
//       startDate: listing.startDate || undefined,
//       endDate: listing.endDate || undefined,
//     };
//     try {
//       const result = await fetchTeamMembers(params);
//       if (result?.success) {
//         const response = result?.data;
//         setTeamMembers(response?.user);
//         setTotalPages(response?.pagination?.totalPages || 1);
//         setTotalbyAll(response?.pagination?.totalUsers || 0);
//       } else {
//         notify(result?.message || "Server Error", "error");
//       }
//     } catch (error) {}
//   };

//   useEffect(() => {
//     fetch_teams();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     listing.page,
//     listing.limit,
//     listing.debouncedSearch,
//     listing.sortBy,
//     listing.sortDir,
//     listing.role,
//     listing.status,
//     listing.accountStatus,
//     listing.startDate,
//     listing.endDate,
//   ]);

//   const handleCheckBalance = async (memberId) => {
//     if (!memberId) return notify("Id is Required", "warning");
//     if (walletBalances[memberId] !== undefined) {
//       setWalletBalances((prev) => ({ ...prev, [memberId]: undefined }));
//       return;
//     }
//     try {
//       setBalanceLoading((prev) => ({ ...prev, [memberId]: true }));
//       const result = await checkTeamWalletById(memberId);
//       if (result?.success) {
//         const balance = result?.data?.wallet?.main?.balance ?? 0;
//         setWalletBalances((prev) => ({ ...prev, [memberId]: balance }));
//       } else {
//         notify(result?.message || "Something went wrong!", "error");
//       }
//     } catch (error) {
//       notify("Not Find Data", "error");
//     } finally {
//       setBalanceLoading((prev) => ({ ...prev, [memberId]: false }));
//     }
//   };

//   const handleOpenFund = (member) => {
//     setSelectedMember(member);
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setSelectedMember(null);
//     fetch_teams();
//     setWalletBalances({});
//   };

//   const viewMember = useCallback(
//     (member) => {
//       if (!member?._id) return notify("Member not found", "error");
//       cacheTeamMember(member._id, member);
//       navigate(`/team/member/${member._id}`, { state: { member } });
//     },
//     [navigate, notify]
//   );

//   const printMember = useCallback(
//     (member) => {
//       const doc = buildTeamMemberDocument(member, brand);
//       if (!doc) return;
//       const ok = printTeamMember(doc);
//       if (!ok) notify("Please allow pop-ups to print", "warning");
//     },
//     [brand, notify]
//   );

//   const pdfMember = useCallback(
//     async (member) => {
//       const doc = buildTeamMemberDocument(member, brand);
//       if (!doc) return;
//       try {
//         await downloadTeamMemberPdf(doc);
//         notify("PDF downloaded", "success");
//       } catch {
//         notify("PDF download failed", "error");
//       }
//     },
//     [brand, notify]
//   );

//   const historyMember = useCallback(
//     (member) => {
//       if (!member?._id) return notify("Member not found", "error");
//       navigate(`/fund/report/${member._id}`);
//     },
//     [navigate, notify]
//   );

//   return (
//     <Main showRightPanel={false} showInfoText={false}>
//       <div className="mt-4">
//         <AppBreadcrumbs
//           items={[
//             { label: "Dashboard", to: "/" },
//             { label: "Reports" },
//             { label: "My Team Members" },
//           ]}
//         />

//         <div className="ds-card mb-3 mt-4 flex items-center justify-between gap-2 flex-wrap">
//           <div className="flex items-center gap-2 min-w-0">
//             <img
//               src={`${REAL_BASE_URL}${userInfo?.logo}`}
//               alt="profile"
//               className="h-10 w-8 sm:h-10 sm:w-10 object-cover rounded-ds shrink-0"
//             />
//             <div className="flex items-center gap-2 whitespace-nowrap min-w-0">
//               <p className="text-[15px] font-semibold text-[var(--text-dark)]">{userInfo?.name}</p>
//               <p className="text-[18px] font-semibold text-[var(--text-muted)]">|</p>
//               <p className="text-[15px] font-semibold text-[var(--text-muted)]">
//                 ID: {userInfo?.userName}
//               </p>
//             </div>
//           </div>
//           <div className="flex items-center gap-2 whitespace-nowrap">
//             <p className="text-[18px] font-semibold text-[var(--text-dark)]">Merchants:</p>
//             <p className="text-[15px] font-semibold text-[var(--text-muted)]">{totalbyall}</p>
//           </div>
//         </div>

//         <div className="ds-card mt-4">
//           <ListingFilters
//             onClear={listing.clearFilters}
//             startDate={listing.startDate}
//             endDate={listing.endDate}
//             onStartDate={listing.setStartDate}
//             onEndDate={listing.setEndDate}
//             search={listing.search}
//             onSearch={listing.setSearch}
//             searchPlaceholder="Search"
//             status={listing.status}
//             onStatus={listing.setStatus}
//             statusOptions={TEAM_STATUS_OPTIONS}
//             statusLabel="Active"
//             actions={
//               <>
//                 <label className="ds-listing-field">
//                   <span className="ds-listing-field__label">Account Status</span>
//                   <CompactSelect
//                     className="ds-filter-status-select"
//                     value={listing.accountStatus || ""}
//                     onChange={listing.setAccountStatus}
//                     options={TEAM_ACCOUNT_STATUS_OPTIONS}
//                     placeholder="All Account Status"
//                     ariaLabel="Account Status"
//                   />
//                 </label>
//                 <label className="ds-listing-field">
//                   <span className="ds-listing-field__label">Role</span>
//                   <CompactSelect
//                     className="ds-filter-status-select"
//                     value={listing.role || ""}
//                     onChange={listing.setRole}
//                     options={[
//                       { value: "", label: "All Roles" },
//                       { value: "retailer", label: "Retailer" },
//                       { value: "distributor", label: "Distributor" },
//                       { value: "super_distributor", label: "Super Distributor" },
//                     ]}
//                     placeholder="All Roles"
//                     ariaLabel="Role"
//                   />
//                 </label>
//               </>
//             }
//             onExport={() =>
//               exportTable(
//                 "team-members",
//                 [
//                   {
//                     label: "Date",
//                     value: (r) => (r?.createdAt ? autoDateFormat(r.createdAt, "full") : ""),
//                   },
//                   { label: "Agent Name", key: "name" },
//                   { label: "Branch Code", value: (r) => r?.parentUserName || r?.parentId?.userName || "" },
//                   { label: "Mobile", key: "phone" },
//                   { label: "Email", key: "email" },
//                   { label: "Rank", key: "role" },
//                   { label: "Active", value: (r) => activeStatusLabel(r) },
//                   { label: "Account Status", value: (r) => r?.accountStatus || "REGISTERED" },
//                 ],
//                 members,
//                 notify
//               )
//             }
//           />

//           <div className="ds-table-wrap ds-scroll">
//             <table className="ds-table ds-table-listing min-w-[1100px]">
//               <thead>
//                 <tr>
//                   <SortableTh
//                     label="Date"
//                     sortKey="date"
//                     activeKey={listing.sortBy}
//                     direction={listing.sortDir}
//                     onSort={listing.toggleSort}
//                   />
//                   <th>Agent Name</th>
//                   <th>UserName</th>
//                   <th>ParentId</th>
//                   <th>Agent Contact</th>
                
//                   <th>Rank</th>
//                   <th>Active</th>
//                   <th>Account Status</th>
//                   <th>Balance</th>
//                   <th>Add Fund</th>
//                   <th className="ds-th-actions">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {members?.length === 0 ? (
//                   <tr>
//                     <td colSpan="11" className="text-center text-[var(--text-muted)]">
//                       NO TEAM AVAILABLE IN TABLE
//                     </td>
//                   </tr>
//                 ) : (
//                   members.map((member, i) => (
//                     <tr key={member?._id || i}>
//                       <td>
//                         {member?.createdAt ? autoDateFormat(member.createdAt, "full") : "N/A"}
//                       </td>
//                       <td className="font-semibold">{member?.name}</td>
//                       <td>{member?.userName || member?.parentId?.userName || "-"}</td>
                      
//                         <td>
//                         <div className="font-semibold">{member?.parentId?.name || "—"}</div>
//                         <div className="text-[11px] text-[var(--text-muted)]">
//                           {member?.parentId?.userName || ""}
//                         </div>
//                       </td>
                
//                         <td>
//                         <div className="font-semibold">{member?.phone || "—"}</div>
//                         <div className="text-[11px] text-[var(--text-muted)]">
//                           {member?.email || ""}
//                         </div>
//                       </td>
//                       <td className="uppercase">{`#${member?.role}`}</td>
//                       <td>
//                         <StatusBadge status={activeStatusLabel(member)} />
//                       </td>
//                       <td>
//                         <StatusBadge status={member?.accountStatus || "REGISTERED"} />
//                       </td>
//                       <td>
//                         <button
//                           type="button"
//                           className="ds-action-btn w-full min-w-[100px]"
//                           disabled={balanceLoading?.[member?._id]}
//                           onClick={() => handleCheckBalance(member?._id)}
//                         >
//                           {balanceLoading?.[member?._id]
//                             ? "Loading..."
//                             : walletBalances?.[member?._id] !== undefined
//                               ? `₹ ${formatAmount(walletBalances[member._id])}`
//                               : "Show Balance"}
//                         </button>
//                       </td>
//                       <td>
//                         <button
//                           type="button"
//                           onClick={() => handleOpenFund(member)}
//                           className="ds-action-btn"
//                         >
//                           Add Fund
//                         </button>
//                       </td>
//                       <td>
//                         <RowActions
//                           onView={() => viewMember(member)}
//                           onPdf={() => pdfMember(member)}
//                           onPrint={() => printMember(member)}
//                           onHistory={() => historyMember(member)}
//                         />
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           <ListingPagination
//             page={listing.page}
//             limit={listing.limit}
//             total={totalbyall}
//             totalPages={totalPages}
//             onPageChange={listing.setPage}
//             onLimit={listing.setLimit}
//             limitOptions={[1, 10, 20, 50, 100]}
//           />
//         </div>
//       </div>
//       {open && <AddFund open={open} close={handleClose} memberData={selectedMember} />}
//     </Main>
//   );
// };

// export default TeamMembers;
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import Main from "./Main";
import AddFund from "../components/AddFund";
import { fetchTeamMembers } from "../api/teamsMemeberApi";
import { autoDateFormat } from "../utils/autoDateFormate";
import { checkTeamWalletById } from "../api/walletsApi";
import { useNavigate } from "react-router-dom";
import { formatAmount } from "../utils/formatAmount";

import { useNotify } from "../context/NotifyContext";
import { useBranding } from "../context/BrandingContext";
import blueLogo from "../assests/newbrand/13.svg";
import {
  buildTeamMemberDocument,
  cacheTeamMember,
  downloadTeamMemberPdf,
  printTeamMember,
} from "../utils/teamMemberDocument";
import {
  ListingFilters,
  ListingPagination,
  SortableTh,
  AppBreadcrumbs,
  RowActions,
  StatusBadge,
  useListingState,
  TEAM_STATUS_OPTIONS,
  TEAM_ACCOUNT_STATUS_OPTIONS,
  CompactSelect,
} from "../components/listing";
import { exportTable } from "../utils/downloadExcel";

const activeStatusLabel = (member) => {
  if (typeof member?.isActive === "boolean") {
    return member.isActive ? "ACTIVE" : "INACTIVE";
  }

  return "INACTIVE";
};

const TeamMembers = () => {
  const { userInfo } = useSelector((state) => state?.auth);
  const { notify } = useNotify();
  const { companyName, legalName, mediaUrl, settings } = useBranding();

  const [open, setOpen] = useState(false);
  const [members, setTeamMembers] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalbyall, setTotalbyAll] = useState(0);

  const [balanceLoading, setBalanceLoading] = useState({});
  const [balanceModal, setBalanceModal] = useState(null);

  const [selectedMember, setSelectedMember] = useState(null);

  const navigate = useNavigate();

  const listing = useListingState({
    sortBy: "date",
    sortDir: "desc",
    includeDates: true,
    startDate: "",
    endDate: "",
    status: "active",
    accountStatus: "",
  });

  const brand = useMemo(() => {
    const logoPath = settings?.logoLightUrl || settings?.logoDarkUrl;

    return {
      companyName,
      legalName,
      logoUrl: logoPath ? mediaUrl(logoPath) : blueLogo,
    };
  }, [companyName, legalName, mediaUrl, settings]);

  const fetch_teams = async () => {
    const params = {
      page: listing.page,
      limit: listing.limit,
      search: listing.debouncedSearch || undefined,
      sortBy: listing.sortBy || undefined,
      sortDir: listing.sortBy ? listing.sortDir : undefined,
      status: listing.status || undefined,
      accountStatus: listing.accountStatus || undefined,
      role: listing.role || undefined,
      startDate: listing.startDate || undefined,
      endDate: listing.endDate || undefined,
    };

    try {
      const result = await fetchTeamMembers(params);

      if (result?.success) {
        const response = result?.data;

        setTeamMembers(response?.user || []);
        setTotalPages(response?.pagination?.totalPages || 1);
        setTotalbyAll(response?.pagination?.totalUsers || 0);
      } else {
        notify(result?.message || "Server Error", "error");
      }
    } catch (error) {
      notify("Unable to fetch team members", "error");
    }
  };

  useEffect(() => {
    fetch_teams();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    listing.page,
    listing.limit,
    listing.debouncedSearch,
    listing.sortBy,
    listing.sortDir,
    listing.role,
    listing.status,
    listing.accountStatus,
    listing.startDate,
    listing.endDate,
  ]);

  const handleCheckBalance = async (member) => {
    const memberId = member?._id;

    if (!memberId) {
      return notify("Id is Required", "warning");
    }

    try {
      setBalanceLoading((prev) => ({
        ...prev,
        [memberId]: true,
      }));

      const result = await checkTeamWalletById(memberId);

      if (result?.success) {
        const wallet = result?.data?.wallet || {};

        const mainBalance = Number(wallet?.main?.balance || 0);
        const mainHold = Number(wallet?.main?.hold || 0);

        console.log("get the wallet",wallet)

        setBalanceModal({
          member,
          currency: wallet?.currency || "INR",

          main: mainBalance,
          hold: mainHold,

          available: Math.max(mainBalance - mainHold, 0),

          addMoney: Number(wallet?.addMoney?.balance || 0),
          addMoneyHold: Number(wallet?.addMoney?.hold || 0),

          aeps: Number(wallet?.aeps?.balance || 0),
          aepsHold: Number(wallet?.aeps?.hold || 0),
        });
      } else {
        notify(
          result?.message || "Unable to fetch wallet balance",
          "error"
        );
      }
    } catch (error) {
      notify("Unable to fetch wallet balance", "error");
    } finally {
      setBalanceLoading((prev) => ({
        ...prev,
        [memberId]: false,
      }));
    }
  };

  const closeBalanceModal = () => {
    setBalanceModal(null);
  };

  const handleOpenFund = (member) => {
    setSelectedMember(member);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedMember(null);
    fetch_teams();
  };

  const viewMember = useCallback(
    (member) => {
      if (!member?._id) {
        return notify("Member not found", "error");
      }

      cacheTeamMember(member._id, member);

      navigate(`/team/member/${member._id}`, {
        state: { member },
      });
    },
    [navigate, notify]
  );

  const printMember = useCallback(
    (member) => {
      const doc = buildTeamMemberDocument(member, brand);

      if (!doc) return;

      const ok = printTeamMember(doc);

      if (!ok) {
        notify("Please allow pop-ups to print", "warning");
      }
    },
    [brand, notify]
  );

  const pdfMember = useCallback(
    async (member) => {
      const doc = buildTeamMemberDocument(member, brand);

      if (!doc) return;

      try {
        await downloadTeamMemberPdf(doc);
        notify("PDF downloaded", "success");
      } catch {
        notify("PDF download failed", "error");
      }
    },
    [brand, notify]
  );

  const historyMember = useCallback(
    (member) => {
      if (!member?._id) {
        return notify("Member not found", "error");
      }

      navigate(`/fund/report/${member._id}`);
    },
    [navigate, notify]
  );

  return (
    <Main showRightPanel={false} showInfoText={false}>
      <div className="mt-4">
        {/* Breadcrumbs */}
        <AppBreadcrumbs
          items={[
            {
              label: "Dashboard",
              to: "/",
            },
            {
              label: "Reports",
            },
            {
              label: "My Team Members",
            },
          ]}
        />

        {/* User Header */}
        <div className="ds-card mb-3 mt-4 flex items-center justify-between gap-2 flex-wrap">
          <div className="flex items-center gap-2 min-w-0">
            <img
              src={`${userInfo?.logo}`}
              alt="profile"
              className="h-10 w-8 sm:h-10 sm:w-10 object-cover rounded-ds shrink-0"
            />

            <div className="flex items-center gap-2 whitespace-nowrap min-w-0">
              <p className="text-[15px] font-semibold text-[var(--text-dark)]">
                {userInfo?.name}
              </p>

              <p className="text-[18px] font-semibold text-[var(--text-muted)]">
                |
              </p>

              <p className="text-[15px] font-semibold text-[var(--text-muted)]">
                ID: {userInfo?.userName}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2 whitespace-nowrap">
            <p className="text-[18px] font-semibold text-[var(--text-dark)]">
              Merchants:
            </p>

            <p className="text-[15px] font-semibold text-[var(--text-muted)]">
              {totalbyall}
            </p>
          </div>
        </div>

        {/* Listing */}
        <div className="ds-card mt-4">
          <ListingFilters
            onClear={listing.clearFilters}
            startDate={listing.startDate}
            endDate={listing.endDate}
            onStartDate={listing.setStartDate}
            onEndDate={listing.setEndDate}
            search={listing.search}
            onSearch={listing.setSearch}
            searchPlaceholder="Search"
            status={listing.status}
            onStatus={listing.setStatus}
            statusOptions={TEAM_STATUS_OPTIONS}
            statusLabel="Active"
            actions={
              <>
                <label className="ds-listing-field">
                  <span className="ds-listing-field__label">
                    Account Status
                  </span>

                  <CompactSelect
                    className="ds-filter-status-select"
                    value={listing.accountStatus || ""}
                    onChange={listing.setAccountStatus}
                    options={TEAM_ACCOUNT_STATUS_OPTIONS}
                    placeholder="All Account Status"
                    ariaLabel="Account Status"
                  />
                </label>

                <label className="ds-listing-field">
                  <span className="ds-listing-field__label">
                    Role
                  </span>

                  <CompactSelect
                    className="ds-filter-status-select"
                    value={listing.role || ""}
                    onChange={listing.setRole}
                    options={[
                      {
                        value: "",
                        label: "All Roles",
                      },
                      {
                        value: "retailer",
                        label: "Retailer",
                      },
                      {
                        value: "distributor",
                        label: "Distributor",
                      },
                      {
                        value: "super_distributor",
                        label: "Super Distributor",
                      },
                    ]}
                    placeholder="All Roles"
                    ariaLabel="Role"
                  />
                </label>
              </>
            }
            onExport={() =>
              exportTable(
                "team-members",
                [
                  {
                    label: "Date",
                    value: (r) =>
                      r?.createdAt
                        ? autoDateFormat(r.createdAt, "full")
                        : "",
                  },
                  {
                    label: "Agent Name",
                    key: "name",
                  },
                  {
                    label: "Branch Code",
                    value: (r) =>
                      r?.parentUserName ||
                      r?.parentId?.userName ||
                      "",
                  },
                  {
                    label: "Mobile",
                    key: "phone",
                  },
                  {
                    label: "Email",
                    key: "email",
                  },
                  {
                    label: "Rank",
                    key: "role",
                  },
                  {
                    label: "Active",
                    value: (r) => activeStatusLabel(r),
                  },
                  {
                    label: "Account Status",
                    value: (r) =>
                      r?.accountStatus || "REGISTERED",
                  },
                ],
                members,
                notify
              )
            }
          />

          {/* Table */}
          <div className="ds-table-wrap ds-scroll">
            <table className="ds-table ds-table-listing min-w-[1100px]">
              <thead>
                <tr>
                  <SortableTh
                    label="Date"
                    sortKey="date"
                    activeKey={listing.sortBy}
                    direction={listing.sortDir}
                    onSort={listing.toggleSort}
                  />

                  <th>Agent Name</th>
                  <th>UserName</th>
                  <th>ParentId</th>
                  <th>Agent Contact</th>
                  <th>Rank</th>
                  <th>Active</th>
                  <th>Account Status</th>
                  <th>Balance</th>
                  <th>Add Fund</th>
                  <th className="ds-th-actions">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {members?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="11"
                      className="text-center text-[var(--text-muted)]"
                    >
                      NO TEAM AVAILABLE IN TABLE
                    </td>
                  </tr>
                ) : (
                  members.map((member, i) => (
                    <tr key={member?._id || i}>
                      {/* Date */}
                      <td>
                        {member?.createdAt
                          ? autoDateFormat(
                              member.createdAt,
                              "full"
                            )
                          : "N/A"}
                      </td>

                      {/* Name */}
                      <td className="font-semibold capitalize">
                        {member?.name}
                      </td>

                      {/* Username */}
                      <td>
                        {member?.userName ||
                          member?.parentId?.userName ||
                          "-"}
                      </td>

                      {/* Parent */}
                      <td>
                        <div className="font-semibold">
                          {member?.parentId?.name || "—"}
                        </div>

                        <div className="text-[11px] text-[var(--text-muted)]">
                          {member?.parentId?.userName || ""}
                        </div>
                      </td>

                      {/* Contact */}
                      <td>
                        <div className="font-semibold">
                          {member?.phone || "—"}
                        </div>

                        <div className="text-[11px] text-[var(--text-muted)]">
                          {member?.email || ""}
                        </div>
                      </td>

                      {/* Rank */}
                      <td className="uppercase">
                        #{member?.role}
                      </td>

                      {/* Active */}
                      <td>
                        <StatusBadge
                          status={activeStatusLabel(member)}
                        />
                      </td>

                      {/* Account Status */}
                      <td>
                        <StatusBadge
                          status={
                            member?.accountStatus ||
                            "REGISTERED"
                          }
                        />
                      </td>

                      {/* Balance */}
                      <td>
                        <button
                          type="button"
                          className="ds-action-btn w-full min-w-[110px]"
                          disabled={
                            balanceLoading?.[member?._id]
                          }
                          onClick={() =>
                            handleCheckBalance(member)
                          }
                        >
                          {balanceLoading?.[member?._id]
                            ? "Loading..."
                            : "Show Balance"}
                        </button>
                      </td>

                      {/* Add Fund */}
                      <td>
                        <button
                          type="button"
                          onClick={() =>
                            handleOpenFund(member)
                          }
                          className="ds-action-btn"
                        >
                          Add Fund
                        </button>
                      </td>

                      {/* Actions */}
                      <td>
  <div className="flex items-center gap-2">
    {!member?.kycId && member?.userName && (
       <button
        type="button"
        onClick={() =>
          navigate(`/merchant/${encodeURIComponent(member.userName)}`)
        }
        className="ds-action-btn"
      >
        KYC
      </button>

    )} 
      {/* <button
        type="button"
        onClick={() =>
          navigate(`/merchant/${encodeURIComponent(member.userName)}`)
        }
        className="ds-action-btn"
      >
        KYC
      </button> */}

    <RowActions
      onView={() => viewMember(member)}
      onPdf={() => pdfMember(member)}
      onPrint={() => printMember(member)}
      onHistory={() => historyMember(member)}
    />
  </div>
</td>
                      {/* <td>
                        <RowActions
                          onView={() => viewMember(member)}
                          onPdf={() => pdfMember(member)}
                          onPrint={() =>
                            printMember(member)
                          }
                          onHistory={() =>
                            historyMember(member)
                          }
                        />
                      </td> */}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <ListingPagination
            page={listing.page}
            limit={listing.limit}
            total={totalbyall}
            totalPages={totalPages}
            onPageChange={listing.setPage}
            onLimit={listing.setLimit}
            limitOptions={[1, 10, 20, 50, 100]}
          />
        </div>
      </div>

      {/* Add Fund */}
      {open && (
        <AddFund
          open={open}
          close={handleClose}
          memberData={selectedMember}
        />
      )}

    {balanceModal && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
    <div className="ds-card p-4 md:p-3 w-[90%] max-w-sm md:max-w-[500px]">
      
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <div>
          <h2 className="text-[15px] font-semibold text-[var(--text-dark)]">
            Wallet Balance
          </h2>

          <p className="text-xs text-[var(--text-muted)] mt-1 capitalize">
            {balanceModal.member?.name || "-"}{" "}
            •{" "}
            {balanceModal.member?.userName || "-"}
          </p>
        </div>

        <button
          type="button"
          onClick={closeBalanceModal}
          className="text-[var(--text-muted)] hover:text-[var(--text-dark)] text-xl"
        >
          ×
        </button>
      </div>

      {/* Main Balance */}
      <div className="rounded-ds border border-[var(--border-color)] p-4 mb-3">
        <p className="text-xs text-[var(--text-muted)]">
          Main Wallet Balance
        </p>

        <p className="text-2xl font-semibold text-[var(--text-dark)] mt-1">
          {balanceModal.currency}{" "}
          {formatAmount(balanceModal.main)}
        </p>
      </div>

      {/* Balance Details */}
      <div className="grid grid-cols-2 gap-3">

        {/* Available */}
        <div className="rounded-ds border border-[var(--border-color)] p-3">
          <p className="text-xs text-[var(--text-muted)]">
            Available
          </p>

          <p className="text-[15px] font-semibold text-[var(--text-dark)] mt-1">
            {balanceModal.currency}{" "}
            {formatAmount(balanceModal.available)}
          </p>
        </div>

        {/* Hold */}
        <div className="rounded-ds border border-[var(--border-color)] p-3">
          <p className="text-xs text-[var(--text-muted)]">
            Hold
          </p>

          <p className="text-[15px] font-semibold text-[var(--text-dark)] mt-1">
            {balanceModal.currency}{" "}
            {formatAmount(balanceModal.hold)}
          </p>
        </div>

        {/* Add Money */}
        <div className="rounded-ds border border-[var(--border-color)] p-3">
          <p className="text-xs text-[var(--text-muted)]">
            Add Money
          </p>

          <p className="text-[15px] font-semibold text-[var(--text-dark)] mt-1">
            {balanceModal.currency}{" "}
            {formatAmount(balanceModal.addMoney)}
          </p>

          {balanceModal.addMoneyHold > 0 && (
            <p className="text-[11px] text-[var(--text-muted)] mt-1">
              Hold: {balanceModal.currency}{" "}
              {formatAmount(balanceModal.addMoneyHold)}
            </p>
          )}
        </div>

        {/* AEPS */}
        <div className="rounded-ds border border-[var(--border-color)] p-3">
          <p className="text-xs text-[var(--text-muted)]">
            AEPS
          </p>

          <p className="text-[15px] font-semibold text-[var(--text-dark)] mt-1">
            {balanceModal.currency}{" "}
            {formatAmount(balanceModal.aeps)}
          </p>

          {balanceModal.aepsHold > 0 && (
            <p className="text-[11px] text-[var(--text-muted)] mt-1">
              Hold: {balanceModal.currency}{" "}
              {formatAmount(balanceModal.aepsHold)}
            </p>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="ds-form-actions mt-4">
        <button
          type="button"
          onClick={closeBalanceModal}
          className="ds-btn ds-btn-secondary"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

      {/* Modal Animation */}
      <style>
        {`
          @keyframes balanceModalIn {
            from {
              opacity: 0;
              transform: translateY(12px) scale(0.97);
            }

            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }
        `}
      </style>
    </Main>
  );
};

export default TeamMembers;